import { FC, MouseEventHandler, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { Dialog, useDialog } from 'components';

import { useNewTransaction } from '..';

const CancelConfirmation: FC = () => {
  const navigate = useNavigate();
  const { transaction } = useNewTransaction();
  const { closeDialog, openDialog, ref } = useDialog();

  /* prettier-ignore */
  const confirmReset: MouseEventHandler = useCallback(e => {
    e.preventDefault();
    openDialog();
  }, [openDialog]);

  return (
    <div id="cancel-dialog" className="w-100">
      <button className="action btn-outline w-100" type="reset" onClick={confirmReset}>
        cancel
      </button>
      <Dialog closeDialog={closeDialog} ref={ref}>
        <div className="d-flex flex-column g-3">
          <h3 className="text-info-dark font-weight-medium">Cancel Gate {!transaction.inbound ? 'Out' : 'In'}</h3>
          <p className="text-info-main">Discard transaction and return to gate access?</p>
          <div className="grid-3 mt-3">
            <button className="btn-outline col-start-2" type="button" onClick={closeDialog}>
              close
            </button>
            <button className="btn-danger col-start-3" type="reset" onClick={() => navigate('/gate')}>
              confirm
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default CancelConfirmation;
